import { render, staticRenderFns } from "./IconFileCsv.vue?vue&type=template&id=d64e8364&scoped=true&"
import script from "./IconFileCsv.vue?vue&type=script&lang=js&"
export * from "./IconFileCsv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64e8364",
  null
  
)

export default component.exports